<div class="passwordless_signup">
  <div *ngIf="showSpinner; else templateRegisration" [mmTestTarget]="'registration-type-spinner'"
    class="passwordless_signup__spinner" aria-busy="true" aria-live="polite">
    <mm-spinner diameter="50"></mm-spinner>
  </div>

  <ng-template #templateRegisration>
    <ul class="passwordless_signup__options">
      <li>

        <a href="#" class="passwordless_signup__options__item" (click)="personalSignup($event)">
          <div>
            <div class="passwordless_signup__options__item__icon" aria-hidden="true">
              <mm-icon name="registration-type-personal"></mm-icon>

            </div>
            <div class="passwordless_signup__options__item__title">
              {{"PAGES.AUTH.REGISTRATION_TYPE.PRIVATE.TITLE" | translate}}
            </div>
          </div>

          <div class="passwordless_signup__options__item__icon_arrow">
            <mm-icon name="arrow-right"></mm-icon>

          </div>
        </a>
      </li>
      <li>

        <a href="#" class="passwordless_signup__options__item" (click)="businessSignup($event)">
          <div>
            <div class="passwordless_signup__options__item__icon" aria-hidden="true">
              <mm-icon name="registration-type-business"></mm-icon>


            </div>
            <div class="passwordless_signup__options__item__title">
              {{"PAGES.AUTH.REGISTRATION_TYPE.BUSINESS.TITLE" | translate}}
            </div>
          </div>

          <div class="passwordless_signup__options__item__icon_arrow">
            <mm-icon name="arrow-right"></mm-icon>

          </div>
        </a>
      </li>
      <li>
        <a href="#" class="passwordless_signup__options__item" (click)="businessMetroSignup($event)">
          <div>
            <div class="passwordless_signup__options__item__icon" aria-hidden="true">
              <mm-icon [isCurrentColor]="false" name="registration-type-metro"></mm-icon>

            </div>
            <div class="passwordless_signup__options__item__title">
              {{"PAGES.AUTH.REGISTRATION_TYPE.BUSINESS_METRO.TITLE" | translate}}
            </div>
          </div>

          <div class="passwordless_signup__options__item__icon_arrow">
            <mm-icon name="arrow-right"></mm-icon>

          </div>
        </a>

      </li>
    </ul>

    <div class="idam-register__legal-text" role="note" [attr.aria-label]="'PAGES.AUTH.REGISTER.LEGAL_SECTION.ARIA_LABEL' | translate">
      <span>
        {{"PAGES.AUTH.REGISTER.LEGAL_TEXT.PWD" | translate}}
      </span>
      <br /><br />
      <span [innerHTML]="
          'PAGES.AUTH.REGISTER.LEGAL_TEXT.TNC'
            | translate: tier1SignupLegalTextParams
            | accessibleLinks
        "></span>

      <br /><br />
    </div>
    <div class="idam-register__extra-links" [innerHTML]="
        'PAGES.AUTH.REGISTER.EXTRA_LINKS'
          | translate: tier1SignupLegalExtraLinks
          | accessibleLinks
      "></div>
  </ng-template>
</div>
